import { ApiRoutes, AppPaginationOptions, QueryError, WithPagination } from '@/common/interfaces';
import { apiExecutor, buildMutation, buildQuery } from '@/common/services';

import { Domain, SearchConsoleAnalyticsDomainsQueryKeys, SearchConsoleAnalyticsRequestData } from '@/modules/Domains';
import { SearchConsoleAnalytics } from '@/modules/DomainsApi';

export const useGetAllSearchConsoleAnalyticsDomainsQuery = (siteId: string, paginationOptions: AppPaginationOptions) =>
  buildQuery<
    WithPagination<Pick<Domain, 'id' | 'name' | 'isGoogleVerificated' | 'isSitesMain'>
  >, QueryError>(
    [SearchConsoleAnalyticsDomainsQueryKeys.GetAll, siteId, paginationOptions],
    async () => {
      const { data } = await apiExecutor.get(ApiRoutes.SiteDomainsSearchConsoleAnalytics.replace(':siteId', siteId), {
        params: paginationOptions
      });
      return data;
    }
  );

export const useGetByIdSearchConsoleAnalyticsDomainsQuery = (siteId: string, domainId: string) =>
  buildQuery<void, QueryError>([SearchConsoleAnalyticsDomainsQueryKeys.GetById, siteId, domainId], async () => {
    const { data } = await apiExecutor.get(
      ApiRoutes.SiteDomainsSearchConsoleAnalyticsById.replace(':siteId', siteId).replace(':domainId', domainId)
    );
    return data;
  });

export const useGetSearchConsoleAnalyticsMutation = (siteId: string, domainId: string) =>
  buildMutation<SearchConsoleAnalytics, QueryError, SearchConsoleAnalyticsRequestData>(
    [SearchConsoleAnalyticsDomainsQueryKeys.Submit, siteId, domainId],
    async (postData) => {
      const { data } = await apiExecutor.post<SearchConsoleAnalytics>(ApiRoutes.SiteDomainsSearchConsoleAnalyticsById.replace(':siteId', siteId).replace(':domainId', domainId), {
        ...postData
      });
      return data;
    }
  );
